import React, { useEffect, useState } from 'react';
import * as api from '../api/api';
import { BASE_URL } from '../api/api';
import axios from 'axios';
import AdminLayout from './AdminLayout';

const ManageHero = () => {
    const [heroData, setHeroData] = useState({
        hero_title: '',
        hero_subtitle: '',
        hero_description: '',
        exp_years: '',
        completed_projects: '',
        client_satisfaction: '',
        hero_image: '',
        contact_highlight_1: '',
        contact_highlight_2: '',
        contact_highlight_3: '',
        contact_highlight_4: ''
    });
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchHeroData = async () => {
            try {
                const { data } = await api.fetchAllConfigs();
                setHeroData(prev => ({
                    ...prev,
                    hero_title: data.hero_title || '',
                    hero_subtitle: data.hero_subtitle || '',
                    hero_description: data.hero_description || '',
                    exp_years: data.exp_years || '',
                    completed_projects: data.completed_projects || '',
                    client_satisfaction: data.client_satisfaction || '',
                    hero_image: data.hero_image || '',
                    contact_highlight_1: data.contact_highlight_1 || '',
                    contact_highlight_2: data.contact_highlight_2 || '',
                    contact_highlight_3: data.contact_highlight_3 || '',
                    contact_highlight_4: data.contact_highlight_4 || ''
                }));
            } catch (error) {
                console.log(error);
            }
        };
        fetchHeroData();
    }, []);

    const handleChange = (e) => {
        setHeroData({ ...heroData, [e.target.name]: e.target.value });
    };

    const uploadFileHandler = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('image', file);
        setUploading(true);

        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };

            const response = await axios.post(`${BASE_URL}/api/upload`, formData, config);
            const data = response.data;
            setHeroData({ ...heroData, hero_image: data.url || data });
            setUploading(false);
            setMessage('Image uploaded successfully!');
        } catch (error) {
            console.error(error);
            setUploading(false);
            setMessage('Upload failed.');
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            await api.updateConfigsBulk(heroData);
            setMessage('Hero section updated successfully!');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            setMessage('Failed to update hero section.');
        }
    };

    return (
        <AdminLayout title="Manage Hero Page">
            <div className="max-w-4xl mx-auto py-8">
                <div className="bg-gray-800 rounded-lg shadow-xl border border-gray-700 p-8">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-500/10 mb-4 border border-indigo-500/20 shadow-[0_0_15px_rgba(99,102,241,0.1)]">
                            <i className="fas fa-home text-3xl text-indigo-500"></i>
                        </div>
                        <h2 className="text-2xl font-bold text-white tracking-tight">Hero Page Personalization</h2>
                        <p className="text-gray-400 mt-2 text-sm">Update your main page titles, counters, and hero background</p>
                    </div>

                    {message && (
                        <div className={`mb-6 p-4 rounded-md flex items-center text-sm font-medium ${message.toLowerCase().includes('failed')
                            ? 'bg-red-900/20 text-red-400 border border-red-500/20'
                            : 'bg-green-900/20 text-green-400 border border-green-500/20'
                            }`}>
                            <i className={`fas ${message.toLowerCase().includes('failed') ? 'fa-exclamation-circle' : 'fa-check-circle'} mr-3 text-lg`}></i>
                            {message}
                        </div>
                    )}

                    <form onSubmit={submitHandler} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-400 mb-2">Main Title Name</label>
                                <input
                                    type="text"
                                    name="hero_title"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.hero_title}
                                    onChange={handleChange}
                                    placeholder="e.g. Manoj Parmar"
                                />
                            </div>

                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-400 mb-2">Subtitle / Roles</label>
                                <input
                                    type="text"
                                    name="hero_subtitle"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.hero_subtitle}
                                    onChange={handleChange}
                                    placeholder="e.g. Full-Stack Software Engineer"
                                />
                            </div>

                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-400 mb-2">Description</label>
                                <textarea
                                    name="hero_description"
                                    rows="3"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.hero_description}
                                    onChange={handleChange}
                                    placeholder="Introduction paragraph..."
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-400 mb-2">Years of Experience</label>
                                <input
                                    type="text"
                                    name="exp_years"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.exp_years}
                                    onChange={handleChange}
                                    placeholder="e.g. 5"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-400 mb-2">Projects Completed</label>
                                <input
                                    type="text"
                                    name="completed_projects"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.completed_projects}
                                    onChange={handleChange}
                                    placeholder="e.g. 25"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-400 mb-2">Client Satisfaction (%)</label>
                                <input
                                    type="text"
                                    name="client_satisfaction"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.client_satisfaction}
                                    onChange={handleChange}
                                    placeholder="e.g. 99"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-400 mb-2">Hero Image URL</label>
                                <input
                                    type="text"
                                    name="hero_image"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                    value={heroData.hero_image}
                                    onChange={handleChange}
                                    placeholder="Upload or path..."
                                />
                            </div>

                            <div className="md:col-span-2 mt-4">
                                <h4 className="text-gray-300 font-bold mb-4 border-b border-gray-700 pb-2 flex items-center">
                                    <i className="fas fa-address-book mr-2 text-indigo-400"></i>
                                    Contact Section Highlights
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Highlight 1</label>
                                        <input
                                            type="text"
                                            name="contact_highlight_1"
                                            className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                            value={heroData.contact_highlight_1}
                                            onChange={handleChange}
                                            placeholder="e.g. Professional Full-Stack Software Engineer"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Highlight 2</label>
                                        <input
                                            type="text"
                                            name="contact_highlight_2"
                                            className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                            value={heroData.contact_highlight_2}
                                            onChange={handleChange}
                                            placeholder="e.g. Desktop & CRM App Development"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Highlight 3</label>
                                        <input
                                            type="text"
                                            name="contact_highlight_3"
                                            className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                            value={heroData.contact_highlight_3}
                                            onChange={handleChange}
                                            placeholder="e.g. AI & Machine Learning Solutions"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Highlight 4</label>
                                        <input
                                            type="text"
                                            name="contact_highlight_4"
                                            className="w-full bg-gray-900 border border-gray-600 rounded-md px-4 py-3 text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                            value={heroData.contact_highlight_4}
                                            onChange={handleChange}
                                            placeholder="e.g. Python & Backend Solutions"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8 border-t border-gray-700 pt-8">
                            <label className="block text-sm font-medium text-gray-400 mb-4 text-center">Update Hero Image</label>
                            <div className="flex flex-col md:flex-row items-center gap-8">
                                <div className="w-full md:w-1/2">
                                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md hover:border-indigo-500 hover:bg-gray-700/30 transition-all cursor-pointer group relative">
                                        <div className="space-y-1 text-center">
                                            <i className="fas fa-cloud-upload-alt text-4xl text-gray-400 group-hover:text-indigo-500 transition-colors mb-3"></i>
                                            <div className="flex text-sm text-gray-400">
                                                <label htmlFor="hero-upload" className="relative cursor-pointer bg-transparent rounded-md font-medium text-indigo-500 hover:text-indigo-400">
                                                    <span>Upload a file</span>
                                                    <input id="hero-upload" name="hero-upload" type="file" className="sr-only" accept="image/*" onChange={uploadFileHandler} />
                                                </label>
                                            </div>
                                            <p className="text-xs text-gray-500">PNG, JPG up to 5MB</p>
                                        </div>
                                    </div>
                                    {uploading && <p className="text-xs text-indigo-500 mt-2 text-center">Uploading...</p>}
                                </div>

                                <div className="w-full md:w-1/2 flex flex-col items-center">
                                    <p className="text-sm text-gray-400 mb-2">Image Preview</p>
                                    <div className="p-2 bg-gray-900 rounded-lg border border-gray-700">
                                        <img
                                            src={api.getImageUrl(heroData.hero_image)}
                                            alt="Preview"
                                            className="h-32 w-auto object-contain rounded"
                                            onError={(e) => { e.target.src = 'assets/images/hero/manoj-removebg.png' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="w-full flex justify-center py-4 px-4 border border-transparent rounded-md shadow-sm text-base font-bold text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all"
                        >
                            <i className="fas fa-save mr-2 mt-1"></i> Save All Hero Changes
                        </button>
                    </form>
                </div>
            </div>
        </AdminLayout>
    );
};

export default ManageHero;
